import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';

import './TostoreShoppingCart.less';


export class TostoreShoppingCart extends CommonComponent {
  constructor(props) {
    super(props);
    this.options = this.props.options;

    this.state = {
      addTostoreShoppingCartShow: false,
      goodsInfo: {},
      selectGoodsModelInfo: {
        buyCount: 0
      },
      cartGoodsNum: 0,
      cartGoodsTotalPrice: 0,
      tostoreTypeFlag: false,
      businesssTimeString: ''
    };
  }

  goodsId = '';
  franchiseeId = '';

  show = (data) => {
    this.goodsId = data.goodsId;
    this.franchiseeId = data.franchisee || ''
    let pageInstance = app.getAppCurrentPage();
    this.setData({
      isShowBottom: pageInstance.data.isShowBottom || ""
    })
    this.getGoodsDetail();
  }

  getGoodsDetail = () => {
    let _this = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: {
        data_id: _this.goodsId,
        sub_shop_app_id: _this.franchiseeId
      },
      method: 'post',
      success: function (res) {
        let goods = res.data[0].form_data;
        let defaultSelect = goods.model_items[0];
        let goodsModel = [];
        let selectModels = [];
        let goodprice = 0;
        let goodstock = 0;
        let goodid;
        let selectText = '';
        let goodimgurl = '';
        if (goods.model_items.length) {
          goodprice = defaultSelect.price;
          goodstock = defaultSelect.stock;
          goodid = defaultSelect.id;
          goodimgurl = defaultSelect.img_url;
        } else {
          goodprice = goods.price;
          goodstock = goods.stock;
          goodimgurl = goods.cover;
        }
        for (let key in goods.model) {
          if (key) {
            let model = goods.model[key];
            goodsModel.push(model);
            selectModels.push(model.subModelId[0]);
            selectText += '“' + model.subModelName[0] + '” ';
          }
        }
        goods.model = goodsModel;
        let businesssTimeString = '';
        if (goods.business_time && goods.business_time.business_time) {
          let goodBusinesssTime = goods.business_time.business_time;
          for (let i = 0; i < goodBusinesssTime.length; i++) {
            businesssTimeString += goodBusinesssTime[i].start_time.substring(0, 2) + ':' + goodBusinesssTime[i].start_time.substring(2, 4) + '-' + goodBusinesssTime[i].end_time.substring(0, 2) + ':' + goodBusinesssTime[i].end_time.substring(2, 4) + '/';
          }
          businesssTimeString = '出售时间：' + businesssTimeString.substring(0, businesssTimeString.length - 1);
        }
        _this.getTostoreCartList();
        _this.setData({
          businesssTimeString: businesssTimeString,
          goodsInfo: goods,
          'addTostoreShoppingCartShow': true,
          'selectGoodsModelInfo.price': goodprice,
          'selectGoodsModelInfo.stock': goodstock,
          'selectGoodsModelInfo.buyTostoreCount': 0,
          'selectGoodsModelInfo.cart_id': '',
          'selectGoodsModelInfo.models': selectModels,
          'selectGoodsModelInfo.modelId': goodid || '',
          'selectGoodsModelInfo.models_text': selectText,
          'selectGoodsModelInfo.imgurl': goodimgurl
        });
      }
    });
  }

  selectGoodsSubModel = (event) => {
    let dataset = event.target.dataset;
    let modelIndex = dataset.modelIndex;
    let submodelIndex = dataset.submodelIndex;
    let nweData = {};
    let selectModels = this.data.selectGoodsModelInfo.models;
    let model = this.data.goodsInfo.model;
    let text = '';

    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];

    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId;
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” ';
        }
      }
    }
    nweData['selectGoodsModelInfo.models'] = selectModels;
    nweData['selectGoodsModelInfo.models_text'] = text;

    this.setData(nweData);
    this.resetSelectCountPrice();
  }

  resetSelectCountPrice = () => {
    let selectModelIds = this.data.selectGoodsModelInfo.models.join(',');
    let modelItems = this.data.goodsInfo.model_items;
    let data = {};
    let cover = this.data.goodsInfo.cover;

    data['selectGoodsModelInfo.buyCount'] = 1;
    data['selectGoodsModelInfo.buyTostoreCount'] = 0;
    for (let i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['selectGoodsModelInfo.stock'] = modelItems[i].stock;
        data['selectGoodsModelInfo.price'] = modelItems[i].price;
        data['selectGoodsModelInfo.modelId'] = modelItems[i].id || '';
        data['selectGoodsModelInfo.imgurl'] = modelItems[i].img_url || cover;
        data['selectGoodsModelInfo.virtual_price'] = modelItems[i].virtual_price;
        data['selectGoodsModelInfo.vipprice'] = modelItems[i].vip_price
        break;
      }
    }
    this.setData(data);
  }

  clickTostoreMinusButton = () => {
    let _this = this;
    let count = this.data.selectGoodsModelInfo.buyTostoreCount;
    if (count <= 0) {
      return;
    }
    if (count <= 1) {
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: [_this.data.selectGoodsModelInfo.cart_id],
          sub_shop_app_id: app.getPageFranchiseeId()
        }
      });
      this.setData({
        'selectGoodsModelInfo.buyTostoreCount': count - 1
      });
      this.getTostoreCartList();
      return;
    }
    this.setData({
      'selectGoodsModelInfo.buyTostoreCount': count
    });
    this.sureAddTostoreShoppingCart('mins');
  }
  
  clickTostorePlusButton= () => {
    let selectGoodsModelInfo = this.data.selectGoodsModelInfo;
    let count = selectGoodsModelInfo.buyTostoreCount;
    let stock = selectGoodsModelInfo.stock;

    if (count >= stock) {
      this.showModal({
        content: '库存不足'
      });
      return;
    }
    this.setData({
      'selectGoodsModelInfo.buyTostoreCount': count
    });
    this.sureAddTostoreShoppingCart('plus');
  }

  sureAddTostoreShoppingCart = (type) => {
    let that = this;
    let goodsNum = that.data.selectGoodsModelInfo.buyTostoreCount;
    if (type == 'plus') {
      goodsNum = goodsNum + 1;
    } else {
      goodsNum = goodsNum - 1;
    }
    let franchiseeId = app.getPageFranchiseeId();
    let param = {
      goods_id: that.data.goodsInfo.id,
      model_id: that.data.selectGoodsModelInfo.modelId || '',
      num: goodsNum,
      sub_shop_app_id: franchiseeId || ''
    };

    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function (res) {
        let data = res.data;
        that.setData({
          'selectGoodsModelInfo.cart_id': data,
          'selectGoodsModelInfo.buyTostoreCount': goodsNum
        });
        that.getTostoreCartList();
      },
      successStatusAbnormal: function (res) {
        that.setData({
          'selectGoodsModelInfo.buyTostoreCount': 0
        });
      }
    })
  }

  readyToTostorePay = () => {
    let franchiseeId = app.getPageFranchiseeId();
    let pagePath = '/orderMeal/pages/previewOrderDetail/previewOrderDetail' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
    if (this.data.cartGoodsNum <= 0 || !this.data.tostoreTypeFlag) {
      return;
    }
    this.hideAddShoppingcart();
    app.turnToPage(pagePath);
  }

  goToShoppingCart = () => {
    let franchiseeId = app.getPageFranchiseeId();
    let pagePath = '/eCommerce/pages/shoppingCart/shoppingCart' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
    this.hideAddShoppingcart();
    app.turnToPage(pagePath);
  }

  getValidateTostore = () => {
    let that = this;
    let franchiseeId = app.getPageFranchiseeId();
    app.sendRequest({
      url: '/index.php?r=AppShop/precheckShoppingCart',
      data: {
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? app.getAppId() : ''
      },
      success: function (res) {
        that.readyToTostorePay();
      },
      successShowModalConfirm: function (res) {
        res.status === 1 && that.goToShoppingCart();
      }
    })
  }

  hideAddShoppingcart = () => {
    this.setData({
      addTostoreShoppingCartShow: false
    });
  }

  getTostoreCartList = () => {
    let that = this;
    let franchiseeId = app.getPageFranchiseeId();
    app.sendRequest({
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: 1,
        page_size: 100,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? app.getAppId() : ''
      },
      success: function (res) {
        let price = 0,
          num = 0,
          addToShoppingCartCount = 0,
          tostoreTypeFlag = false;

        for (let i = res.data.length - 1; i >= 0; i--) {
          let data = res.data[i];
          if (data.goods_type == 3) {
            tostoreTypeFlag = true;
            price += +data.num * +data.price;
            num += +data.num;
          }
          if (this.goodsId == data.goods_id) {
            addToShoppingCartCount = data.num;
            that.cart_id = data.id;
          }
        }
        that.setData({
          tostoreTypeFlag: tostoreTypeFlag,
          cartGoodsNum: num,
          cartGoodsTotalPrice: price.toFixed(2),
          addToShoppingCartCount: addToShoppingCartCount
        });
      }
    })
  }

  stopPropagation = (event) => {
    event.stopPropagation();
  }
  

  render() {
    const {
      addTostoreShoppingCartShow,
      goodsInfo,
      selectGoodsModelInfo,
      cartGoodsNum,
      cartGoodsTotalPrice,
      tostoreTypeFlag,
      isShowBottom,
      businesssTimeString
    } = this.state;
    return (
      <div className="common-component tostore-shopping-cart tostorePayDialog page-addshoppingcart-dialog" hidden={!addTostoreShoppingCartShow} onClick={this.hideAddShoppingcart}>
        <div className="page-bottom-dialog" style={isShowBottom ? { bottom: '1rem'} : {}} onClick={this.stopPropagation} >
          <div className="page-bottom-content">
            <div className="pay-close-dialog page-dialog-close" onClick={this.hideAddShoppingcart}>×</div>
            <div className="dialog-block-item">
              <div className="pay-goods-baseinfo">
                <div className="pay-goods-title ellipsis">{ goodsInfo.title }</div>
              </div>
            </div>
            <div className="dialog-block-item" hidden={ !(goodsInfo.model_items && goodsInfo.model_items.length) } style={{marginBottom: 0}}>
              <div className="pay-goods-models" >
                {
                  goodsInfo.model && goodsInfo.model.map((model, modelIndex) => (
                    <div key={modelIndex}>
                      <span style={{verticalAlign:'top', marginTop:'0.2rem', width:'1.2rem', display:'inline-block', textAlign:'right', fontSize:'.24rem'}}>{ model.name }：</span>
                      <span className="pills-list" style={{textAlign:'center', maxWidth:'5.28rem'}}>
                        {
                          model.subModelName.map((name, index) => (
                            <label className={`subModel ${ selectGoodsModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : '' }`} key={index} data-model-index={ modelIndex } data-submodel-index={ index } data-submodel-id={ model.subModelId[index] } onClick={this.selectGoodsSubModel}>{ name }</label>
                          ))
                        }
                      </span>
                    </div>
                  ))
                }
              </div>
            </div>
            <div className="dialog-block-item">
              <div className="pay-goods-price clearfix">
                <div className="pay-current-price" style={{fontSize: '16px'}}>¥{ selectGoodsModelInfo.price }</div>
                <div className="pull-right">
                  {goodsInfo.goods_type != 3 && <label>库存 <span className="pay-goods-stock">{ selectGoodsModelInfo.stock }</span></label>}
                  <div className="quantity">
                    <label className={`minus ${ selectGoodsModelInfo.buyTostoreCount <= 0 ? 'disabled' : '' }`}></label>
                    <span className="pay-buy-count" style={{margin: 'auto 10px'}}>{ selectGoodsModelInfo.buyTostoreCount }</span>
                    <label className={`plus ${ selectGoodsModelInfo.buyTostoreCount >= selectGoodsModelInfo.stock ? 'disabled' : '' }`}></label>
                    <div className="response-area response-area-minus" onClick={this.clickTostoreMinusButton}></div>
                    <div className="response-area response-area-plus" onClick={this.clickTostorePlusButton}></div>
                  </div>
                </div>
              </div>
              <div style={{fontSize:'12px', marginTop:'10px', color:'#c9c9c9', textAlign: 'center'}}>{businesssTimeString}</div>
            </div>
            <div className="toStore-bottom-nav">
              <div className="bottom-nav-detail" onClick={this.goToShoppingCart}><label className="icon-shoppingcart ico-moon">{cartGoodsNum != 0 && <label className="toStore-cart-tip">{ cartGoodsNum }</label>}</label><span>¥{ cartGoodsTotalPrice }</span></div>
              <div className={`bottom-nav-ready ${ cartGoodsNum == 0 ? 'disabled': '' } ${tostoreTypeFlag ? '' :'disabled'}`} onClick={this.getValidateTostore}>选好了</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/tostore-shopping-cart/TostoreShoppingCart.jsx